import { FieldProperty } from './field-property';

/* istanbul ignore file */
export class FieldAndValue {
    kendoKey: string;
    fieldId: any;
    currentValue: any;
    value: any;
    dataId?: any;
    gridItemId?: any;
    richTextValue?: string;
    richTextCurrentValue?: string;
    fieldType: FieldProperty;
    currentReportRowId?: string;
    siteId: string;
}
